<template>
  <BQdtCard
    name="turnoverHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'DimensionsHelp',

  components: { BQdtCard },
}
</script>
